<app-form-step-instructions
	[form]="form"
	variant="editable"
	[showSectionHeader]="showsInstructionsSectionDivider"
/>

@if (showsInstructionsSectionDivider) {
	<tec-divider></tec-divider>
}

<div [formGroup]="form">
	<app-form-step-fields-section
		[form]="form"
		[fieldsArray]="fieldsArray"
		[preset]="preset"
		[primaryField]="primaryField"
		[selectedLocaleId]="selectedStepLocaleId"
	/>
</div>
